import { enumUtil } from '@/utils';

const EntradaSaidaEnumerator = Object.freeze({
  Entrada: new enumUtil.EnumBase('E', 'Entrada'),
  Saida: new enumUtil.EnumBase('S', 'Saida'),
});

const OperacaoEntradaSaidaEnumerator = Object.freeze(
  {
    Todos: new enumUtil.EnumBase('', ''),
    Entrada: new enumUtil.EnumBase('E', 'Entrada'),
    Saida: new enumUtil.EnumBase('S', 'Saida'),
  },
);

const TipoOperacaoEnumeratorSaida = Object.freeze(
  {
    AcertoEmprestimoEntrada: new enumUtil.EnumBase('AEE', 'Acerto empréstimo entrada'),
    AjusteEstoqueSaida: new enumUtil.EnumBase('AJS', 'Ajuste de estoque saída'),
    BaixaReserva: new enumUtil.EnumBase('BAI', 'Baixa reserva'),
    ComplementarSaida: new enumUtil.EnumBase('CPS', 'Complementar saída'),
    DevolucaoFornecedor: new enumUtil.EnumBase('DEF', 'Devolução fornecedor'),
    EmprestimoSaida: new enumUtil.EnumBase('EMS', 'Empréstimo saída'),
    GratisSaida: new enumUtil.EnumBase('GRS', 'Grátis'),
    NfeRecebimento: new enumUtil.EnumBase('NFR', 'NFC-e de recebimento'),
    NfeAjusteSaida: new enumUtil.EnumBase('NAS', 'NF-e de ajuste saída'),
    Orcamento: new enumUtil.EnumBase('ORC', 'Orçamento'),
    OutrasSaidas: new enumUtil.EnumBase('OTS', 'Outras saídas'),
    Reserva: new enumUtil.EnumBase('RES', 'Reserva'),
    TransferenciaSaida: new enumUtil.EnumBase('TRS', 'Transferência'),
    Venda: new enumUtil.EnumBase('VND', 'Venda'),
  },
);

const TipoOperacaoEnumeratorEntrada = Object.freeze(
  {
    AcertoEmprestimoSaida: new enumUtil.EnumBase('AES', 'Acerto empréstimo saída'),
    AjusteEstoqueEntrada: new enumUtil.EnumBase('AJE', 'Ajuste de estoque entrada'),
    AjusteManual: new enumUtil.EnumBase('AJM', 'Ajuste manual'),
    ComplementarEntrada: new enumUtil.EnumBase('CPE', 'Complementar entrada'),
    Compra: new enumUtil.EnumBase('COM', 'Compra'),
    Cotacao: new enumUtil.EnumBase('COT', 'Cotação'),
    DevolucaoCliente: new enumUtil.EnumBase('DEV', 'Devolução entrada'),
    EmprestimoEntrada: new enumUtil.EnumBase('EME', 'Empréstimo entrada'),
    Encomenda: new enumUtil.EnumBase('ENC', 'Encomenda'),
    GratisEntrada: new enumUtil.EnumBase('GRE', 'Grátis'),
    NfeAjusteEntrada: new enumUtil.EnumBase('NAE', 'NF-e de ajuste entrada'),
    OutrasEntradas: new enumUtil.EnumBase('OTE', 'Outras entradas'),
    PedidoCompra: new enumUtil.EnumBase('PED', 'Pedido de compra'),
    RetornoReserva: new enumUtil.EnumBase('RET', 'Retorno de reserva'),
    TransferenciaEntrada: new enumUtil.EnumBase('TRE', 'Transferência'),
  },
);

const TipoBaixaEstoque = Object.freeze(
  {
    None: new enumUtil.EnumBase(0, ''),
    Gravar: new enumUtil.EnumBase(1, 'Ao gravar'),
    Receber: new enumUtil.EnumBase(2, 'Ao receber'),
    Efetivar: new enumUtil.EnumBase(3, 'Ao efetivar'),
  },
);

export { EntradaSaidaEnumerator, OperacaoEntradaSaidaEnumerator, TipoOperacaoEnumeratorEntrada, TipoOperacaoEnumeratorSaida, TipoBaixaEstoque };
